module.exports = __webpack_public_path__ + "images/tips/more-help@1x.d8d442e8f783a8517c8e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/more-help@1x.png
// module id = yfo3
// module chunks = 1